import { GsiButtonConfiguration } from 'google-one-tap';

export const GOOGLE_BUTTON_CONFIGURATIONS: { [key: string]: GsiButtonConfiguration } = {
  STANDARD_BLUE: {
    type: 'standard',
    theme: 'filled_blue',
    size: 'medium',
    text: 'continue_with'
  },
  ICON: {
    type: 'icon',
    theme: 'outline',
    size: 'large',
    text: 'signin_with'
  }
};
